export enum DateRangeFilterType {
  FILTER_BY_PRESET = 'FILTER_BY_PRESET',
  CUSTOM_DATES = 'CUSTOM_DATES',
  FILTER_BY_TIME = 'FILTER_BY_TIME',
  FILTER_BY_TRADING_PERIOD = 'FILTER_BY_TRADING_PERIOD',
}

export enum DateRangeFilterPresets {
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  THIS_WEEK = 'THIS_WEEK',
  THIS_MONTH = 'THIS_MONTH',
  THIS_QUARTER = 'THIS_QUARTER',
  THIS_YEAR = 'THIS_YEAR',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_30_DAYS = 'LAST_30_DAYS',
  LAST_WEEK = 'LAST_WEEK',
  LAST_MONTH = 'LAST_MONTH',
  LAST_QUARTER = 'LAST_QUARTER',
  LAST_YEAR = 'LAST_YEAR',
}

export enum WidgetChartType {
  TABLE = 'table',
  LINE = 'line',
  PIE = 'pie',
  BAR = 'bar',
  METRIC = 'metric',
  CARD = 'card',
}

export enum ReportTypes {
  DAILY_SALES_SUMMARY = 'DAILY_SALES_SUMMARY',
}

export enum DateRangeGranularity {
  SECOND = 'second',
  MINUTE = 'minute',
  HOUR = 'hour',
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}

export enum FilterOperator {
  EQUALS = 'equals',
  NOT_EQUALS = 'notEquals',
  CONTAINS = 'contains',
  NOT_CONTAINS = 'notContains',
  GREATER_THAN = 'gt',
  GREATER_THEN_EQUAL = 'gte',
  LESS_THAN = 'lt',
  LESS_THAN_EQUAL = 'lte',
}

export enum ColumnType {
  NUMBER = 'number',
  MONEY = 'money',
  DATE = 'date',
  TIME = 'time',
  PERCENT = 'percent',
  EXPORT = 'export',
  STRING = 'string',
  ENUM = 'enum',
  PREVIEW = 'preview',
  MONEY_ROUND_DOWN = 'money_round_down',
}

export enum ColumnSize {
  SMALL = 'small',
  OPTION = 'option',
  REGULAR = 'regular',
}

export enum ReportFilterKey {
  VENUES = 'venues',
  STORES = 'stores',
  DEVICES = 'devices',
  SALES_CHANNELS = 'salesChannels',
  PAYMENT_TYPES = 'paymentTypes',
  ORDER_TYPES = 'orderTypes',
  STAFF = 'staff',
  REFUND_REASONS = 'refundReasons',
}

export enum ReportSegment {
  ORDER_COMPLETED = 'Orders.completedOrders',
  ORDER_VOID = 'Orders.voidOrders',
  ORDER_ITEM_COMPLETED = 'OrderItems.completedItems',
  ORDER_ITEM_VOID = 'OrderItems.voidItems',
  ORDER_REFUNDED = 'Orders.refundedOrders',
  NON_VOIDED_ORDERS = 'Orders.nonVoidedOrders',
  NON_VOIDED_ITEMS = 'OrderItems.nonVoidedItems',
  GROUP_BY_DAY = 'Orders.updatedAt.day',
  GROUP_BY_WEEK = 'Orders.updatedAt.week',
  GROUP_BY_MONTH = 'Orders.updatedAt.month',
  PRODUCTS_ONLY = 'OrderItems.productsOnly',
}

export enum PaymentSummarySegment {
  PAYMENT_METHOD_NAME = 'OrderPayments.paymentTypeName',
  CARD_TYPE = 'OrderPayments.cardType',
}
